<template>
  <div
    ref="chartContainer"
    class="chart-container"
    style="width: 100%; height: 100%"
  ></div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";

let obj = {
  xData: [2019,2020,2021,2022,2023],
  legend: ['强筋', '中筋', '弱筋',],
  lineData: [
    {
      name: '强筋',
      data: [20, 19, 20, 23, 25, 29, 27,28,29,26,24,23,25],
    },
    {
      name: '中筋',
      data: [20, 19, 20, 23, 25, 29, 27,28,29,26,24,23,26],
    },
    {
      name: '弱筋',
      data: [20, 19, 20, 23, 25, 29, 27,28,29,26,24,23,16],
    },
  ]
}
let colorStop=[
  {
    start:'rgba(0, 142, 255, 0.1)',
    end:'rgba(0, 142, 255, 0.6)'
  },
  {
    start:'rgba(255, 219, 14,0.1)',
    end:'rgba(255, 219, 14, 0.6)'
  },
  {
    start:'rgba(0, 242, 240,0.1)',
    end:'rgba(0, 242, 240,06)'
  },



]
let serData = []
obj.lineData.forEach((item,index) => {
  serData.push({
    name: item.name,
    type: "line",
    stack: "all",
    showSymbol: true,
    symbolSize: 12,
    symbol: "emptyCircle",
    lineStyle: {
    },
    itemStyle: {
      borderWidth: 2,
    },
    areaStyle: {
      color: {
        type: "linear",
        x: 0,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: [
          {
            offset: 0,
            color:colorStop[index]?colorStop[index].end:'rgba(0, 142, 255, 0.6)',
          },
          {
            offset: 1,
            color: colorStop[index]?colorStop[index].start:'rgba(0, 142, 255, 0.02)',
          },
        ],
        globalCoord: false, // 缺省为 false
      },
    },
    data: item.data,
  })
})

// 创建ECharts配置对象
const option = {
  // backgroundColor: "#031d47",
  title: {
    text: '单位(元)',
    top: "6%",
    textAlign: "left",
    left: "7%",
    textStyle: {
      color: "#fff",
      fontSize: 18,
      fontWeight: "600",
    },
  },
  color: [
    '#159AFF',
    '#E3F170',
    '#66E193',

  ],
  legend: {
    icon: 'roundRect',
    top: '8%',
    //   left: 'center',
    orient: 'horizontal', //图例方向【horizontal/vertical】
    itemHeight: 15, //修改icon图形大小
    itemWidth: 15, //修改icon图形大小
    itemGap: 50,
    textStyle: {
      fontSize: 12,
      color: '#fff',
      padding: [0, 8],
    },
    data: obj.legend,
  },
  tooltip: {
    show: true,
    trigger: "axis",
    // backgroundColor: "#0a2b45", // 设置背景颜色
    textStyle: {
      color: '#fff',
      fontSize: 14,
    },
    borderColor: "rgba(255, 255, 255, .16)",
    axisPointer: {
      lineStyle: {
        color: "rgba(28, 124, 196)",
      },
    },

    formatter: (params) => {
      let arr = [...params];
      let str = '';
      arr.forEach((item, index) => {
        str += item.marker + item.seriesName + '  ' + item.data + '<br />';
      });
      str = arr[0].name + '<br />' + str;
      return str;
    },
  },


  grid: {
    top: "20%",
    left: "8%",
    right: "8%",
    bottom: "15%",
    containLabel: true,
  },
  xAxis: [
    {
      type: "category",
      axisLine: {
        onZero:true,
        lineStyle: {
          color: "#81b0d0",
        },
      },
      axisLabel: {
        interval: 0,
        align: "center",
        margin: 10,
        color: "#fff",
        rotate: 0,
        textStyle: {
          fontSize: 14,
        },
      },
      splitLine: {
        show: false,
      },
      axisTick: {
        show: false,
      },
      boundaryGap: false,
      data:obj.xData,
    },
  ],

  yAxis: [
    {
      type: "value",
      // name: "（件）",
      nameTextStyle: {
        //y轴上方单位的颜色
        color: "#fff",
      },
      // splitNumber: 6,
      axisLine: {
        show: false,
        lineStyle: {
          color: "#81b0d0",
        },
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: "rgba(221, 228, 241,.3)",
          // type: "dashed",
        },
      },
      axisLabel: {
        color: "rgb(139, 143, 147)",
        textStyle: {
          fontSize: 14,
        },
      },
      axisTick: {
        show: false,
      },
    },
  ],
  series: serData,

};

// 创建ECharts实例的ref
const chartContainer = ref(null);

// 初始化ECharts实例
onMounted(() => {
  if (chartContainer.value) {
    const chartInstance = echarts.init(chartContainer.value);
    chartInstance.setOption(option);


    // 监听窗口尺寸变化
    window.addEventListener("resize", () => {
      chartInstance.resize();
    });
  }
});
</script>

<style scoped>
.chart-container {
  height: 400px; /* 或者自定义高度 */
  width: 100%;
}
</style>
